<template>
  <div>
    <b-modal
        :title="$t('Joined participants report')"
        v-model="show"
        dialog-class="trans-modal bg-app"
        :hide-footer="true"
        size="lg"
        no-close-on-backdrop>
      <ValidationObserver ref="form" tag="form" @submit.prevent="exportFile()">
        <b-row>
          <div class="col-md-12">
            <label>{{$t('Meeting time')}}</label>
          </div>
          <div class="col-md-6">
            <b-form-group>
              <ValidationProvider rules="required" v-slot="{ errors }">
                <b-form-timepicker v-model="formData.fromTime" class="input-trans" :hide-header="false" :placeholder="$t('Start time')" :disabled="loading" locale="vi" />
                <div class="validate-error">{{ errors[0] }}</div>
              </ValidationProvider>
            </b-form-group>
          </div>
          <div class="col-md-6">
            <b-form-group>
              <ValidationProvider rules="required" v-slot="{ errors }">
                <b-form-timepicker v-model="formData.toTime" class="input-trans"  :hide-header="false" :placeholder="$t('End time')" :disabled="loading" locale="vi"/>
                <div class="validate-error">{{ errors[0] }}</div>
              </ValidationProvider>
            </b-form-group>
          </div>
        </b-row>
        <b-row>
          <div class="col-md-12">
            <b-form-group>
              <ValidationProvider rules="required" v-slot="{ errors }">
                <b-form-datepicker v-model="formData.date" class="input-trans" :hide-header="false" :placeholder="$t('Date')" :disabled="loading" :locale="locale" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" />
                <div class="validate-error">{{ errors[0] }}</div>
              </ValidationProvider>
            </b-form-group>
          </div>
        </b-row>
        <b-form-group class="mb-0">
          <b-button type="submit" pill size="lg" class="btn-block btn-trans-primary" :disabled="loading">
            {{
              $t("Export to Excel")
            }}
          </b-button>
        </b-form-group>
      </ValidationObserver>
    </b-modal>
    <PanelLoading :show="loading" message="Saving data"/>
  </div>
</template>

<script>
import dateformat from "dateformat";
import meetingService from "../services/meeting_service";
import dialogHelper from "../helpers/dialog_helper";
import appHelper from "../helpers/app_helper";

export default {
  name: "ReportParticipantsModal",
  data() {
    return {
      loading: false,
      show: false,
      locale: "en",
      formData: {
        id: null,
        isGuest: false,
        fromTime: "",
        toTime: "",
        date: ""
      }
    }
  },
  created() {
    this.locale = this.$store.getters.languageCode;
  },
  methods: {
    async exportFile() {
      this.loading = true;
      let response = await meetingService.meetingParticipantExport(this.formData);
      this.loading = false;
      if (!response)
        return;

      if (!response.startsWith("OK|")) {
        dialogHelper.alert(response, "error");
        return;
      }

      this.show = false;
      await appHelper.downloadFile(response.substr(3))
    },
    open(idSchedule, isGuest) {
      this.formData = {
        id: idSchedule,
        isGuest: isGuest,
        fromTime: "08:00",
        toTime: "18:00",
        date: dateformat(new Date(), this.$t("yyyy-mm-dd"))
      }

      this.show = true
    }
  }
}
</script>

<style scoped>

</style>